var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":`Write for me!`,"description":`Reporting`}}),_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":"Profile"},model:{value:(_vm.profile),callback:function ($$v) {_vm.profile=$$v},expression:"profile"}}),_c('v-btn',{on:{"click":_vm.reportProfile}},[_vm._v(" Report Profile ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }